'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'people-roof';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e537';
var svgPathData = 'M295.2 17.7c-4.5-2.3-9.8-2.3-14.3 0l-256 128c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2L288 49.9 536.8 174.3c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-256-128zM256 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-64 96c-70.7 0-128 57.3-128 128l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16c0-53 43-96 96-96s96 43 96 96l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16c0-70.7-57.3-128-128-128zM128 224a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm320-80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM128 352c-53 0-96 43-96 96l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16c0-34 26.5-61.8 59.9-63.9 4.3-11 9.7-21.6 16-31.4-3.9-.5-7.9-.7-12-.7zm324.1 32.1C485.5 386.2 512 414 512 448l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16c0-53-43-96-96-96-4.1 0-8.1 .3-12 .7 6.3 9.8 11.7 20.3 16 31.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPeopleRoof = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;